/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: w2GXN278dkQ2gQTVQnPehW
// Component: MmbJYtYh-0Eh

import * as React from "react";

import {
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  Flex as Flex__,
  PlasmicImg as PlasmicImg__,
  StrictProps,
  useTrigger,
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";

import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: w2GXN278dkQ2gQTVQnPehW/styleTokensProvider

import "@plasmicapp/react-web/lib/plasmic.css";

import projectcss from "./plasmic_plasmic_kit_data_binding.module.css"; // plasmic-import: w2GXN278dkQ2gQTVQnPehW/projectcss
import sty from "./PlasmicCopilotPromptImage.module.css"; // plasmic-import: MmbJYtYh-0Eh/css

import CircleCloseIcon from "../plasmic_kit_design_system/icons/PlasmicIcon__CircleClose"; // plasmic-import: 5kR2BNf5c2/icon
import imageUYmVmRYjy from "./images/image.png"; // plasmic-import: UYmVmRYjy/picture

createPlasmicElementProxy;

export type PlasmicCopilotPromptImage__VariantMembers = {};
export type PlasmicCopilotPromptImage__VariantsArgs = {};
type VariantPropType = keyof PlasmicCopilotPromptImage__VariantsArgs;
export const PlasmicCopilotPromptImage__VariantProps =
  new Array<VariantPropType>();

export type PlasmicCopilotPromptImage__ArgsType = {};
type ArgPropType = keyof PlasmicCopilotPromptImage__ArgsType;
export const PlasmicCopilotPromptImage__ArgProps = new Array<ArgPropType>();

export type PlasmicCopilotPromptImage__OverridesType = {
  root?: Flex__<"div">;
  img?: Flex__<typeof PlasmicImg__>;
  closeIconContainer?: Flex__<"div">;
  svg?: Flex__<"svg">;
};

export interface DefaultCopilotPromptImageProps {
  className?: string;
}

const $$ = {};

function PlasmicCopilotPromptImage__RenderFunc(props: {
  variants: PlasmicCopilotPromptImage__VariantsArgs;
  args: PlasmicCopilotPromptImage__ArgsType;
  overrides: PlasmicCopilotPromptImage__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );

  const $props = {
    ...args,
    ...variants,
  };

  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const [isRootHover, triggerRootHoverProps] = useTrigger("useHover", {});
  const triggers = {
    hover_root: isRootHover,
  };

  const styleTokensClassNames = _useStyleTokens();

  return (
    <div
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        projectcss.all,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        styleTokensClassNames,
        sty.root
      )}
      data-plasmic-trigger-props={[triggerRootHoverProps]}
    >
      <PlasmicImg__
        data-plasmic-name={"img"}
        data-plasmic-override={overrides.img}
        alt={""}
        className={classNames(sty.img)}
        displayHeight={"50px"}
        displayMaxHeight={"none"}
        displayMaxWidth={"100%"}
        displayMinHeight={"0"}
        displayMinWidth={"0"}
        displayWidth={"50px"}
        loading={"lazy"}
        src={{
          src: imageUYmVmRYjy,
          fullWidth: 1,
          fullHeight: 1,
          aspectRatio: undefined,
        }}
      />

      <div
        data-plasmic-name={"closeIconContainer"}
        data-plasmic-override={overrides.closeIconContainer}
        className={classNames(projectcss.all, sty.closeIconContainer)}
      >
        <CircleCloseIcon
          data-plasmic-name={"svg"}
          data-plasmic-override={overrides.svg}
          className={classNames(projectcss.all, sty.svg)}
          role={"img"}
        />
      </div>
    </div>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  root: ["root", "img", "closeIconContainer", "svg"],
  img: ["img"],
  closeIconContainer: ["closeIconContainer", "svg"],
  svg: ["svg"],
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  root: "div";
  img: typeof PlasmicImg__;
  closeIconContainer: "div";
  svg: "svg";
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicCopilotPromptImage__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicCopilotPromptImage__VariantsArgs;
    args?: PlasmicCopilotPromptImage__ArgsType;
    overrides?: NodeOverridesType<T>;
  } & Omit<PlasmicCopilotPromptImage__VariantsArgs, ReservedPropsType> & // Specify variants directly as props
    // Specify args directly as props
    Omit<PlasmicCopilotPromptImage__ArgsType, ReservedPropsType> &
    // Specify overrides for each element directly as props
    Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    // Specify props for the root element
    Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicCopilotPromptImage__ArgProps,
          internalVariantPropNames: PlasmicCopilotPromptImage__VariantProps,
        }),
      [props, nodeName]
    );
    return PlasmicCopilotPromptImage__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName,
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicCopilotPromptImage";
  } else {
    func.displayName = `PlasmicCopilotPromptImage.${nodeName}`;
  }
  return func;
}

export const PlasmicCopilotPromptImage = Object.assign(
  // Top-level PlasmicCopilotPromptImage renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    img: makeNodeComponent("img"),
    closeIconContainer: makeNodeComponent("closeIconContainer"),
    svg: makeNodeComponent("svg"),

    // Metadata about props expected for PlasmicCopilotPromptImage
    internalVariantProps: PlasmicCopilotPromptImage__VariantProps,
    internalArgProps: PlasmicCopilotPromptImage__ArgProps,
  }
);

export default PlasmicCopilotPromptImage;
/* prettier-ignore-end */
